import { baseEntityReducers, baseInitialState } from './base/baseModelStore';
import { fetchEntitiesMap } from './base/baseModelThunks';
import { ModelReducers } from './modelReducers';
import { createSlice } from '@reduxjs/toolkit';
import { httpClient } from '../infrastructure/http/HttpClient';
import { AxiosResponseTransformer } from 'axios';

const slice = createSlice({
  name: ModelReducers.photos,
  initialState: baseInitialState<string[]>(),
  reducers: {
    ...baseEntityReducers(),
  },
});

const thunks = {
  getEntities: fetchEntitiesMap(ModelReducers.photos, slice.actions, ([id]) =>
    httpClient.get(`chambers/${id}/photos`, {
      transformResponse: (httpClient.defaults.transformResponse as AxiosResponseTransformer[]).concat(
        (data: string[]) => {
          return {
            [id]: data,
          };
        }
      ),
    })
  ),
};

export const photosEntity = {
  reducer: slice.reducer,
  actions: slice.actions,
  thunks,
} as {
  reducer: typeof slice.reducer;
  actions: typeof slice.actions;
  thunks: typeof thunks;
};
